export function verifyIsMobileAndroid() {
    const isMobileAndroid =
        typeof window !== 'undefined'
            ? Boolean(navigator.userAgent.match(/Android/i))
            : false
    return isMobileAndroid
}
